import React, { useState } from 'react';

import OverlayMenu from './OverlayMenu';
import { warn_message_style, message_style_second } from '../common/Common_styles';
import { noDescContent } from './SpecialComponentContainer';

const Tel = (props) => {
  // Property value
  const { value, name, id } = props
  // Property functions
  const { menuOnShow, menuOnHide, updateComponent } = props
  
  const onUpdate = (updatedName, updatedValue) => {
    updateComponent({
      [updatedName]: updatedValue,
    })
  }
  
  const onShow = (e) => {
    menuOnShow()
  }

  const onHide = (e) => {
    menuOnHide()
  }

  // const overflowRowFlag = value.length > 65 ? true : false
 
  return (
    <OverlayMenu
      id={id}
      name={name}
      value={value}
      onUpdate={onUpdate}
      onShow={onShow} onHide={onHide}>
      <div style={{paddingBottom: 2.5, cursor: 'default'}}>
        {value.trim() !== "" ? (
          <p style={text_style}> 
            {value}
          </p>
        ) : (
          noDescContent()
        )}
      </div>
      <button class="button-component">
        {name.trim() !== "" ? name : "연락처 입력" }
      </button>
    </OverlayMenu>
  )
}

const text_style = {
  textAlign: 'left',
}

export default Tel